import styled from 'styled-components';
import { ReactNode } from 'react';

export const CarouselWrapper = styled.div<{
  $isOverflowHidden?: any;
  className?: string;
  style?: React.CSSProperties;
  children?: ReactNode;
}>`
  position: relative;
  overflow: ${(props) => (props.$isOverflowHidden > 0 ? 'hidden' : 'visible')};
`;
CarouselWrapper.displayName = 'CarouselWrapper';

export const CarouselSlider = styled.div<{ $sideSpacesOnDesktop?: boolean }>`
  display: flex;
  transition: transform 0.5s;
  @media (min-width: 1024px) {
    padding: ${(props) => (props.$sideSpacesOnDesktop ? '0 40px' : '0px')};
  }
`;
CarouselSlider.displayName = 'CarouselSlider';

export const CarouselSlideLeft = styled.div<{
  $staticArrows?: boolean;
  onClick?: (e: MouseEvent) => void;
}>`
  cursor: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle cx='30' cy='30' r='30' transform='rotate(90 30 30)' fill='%23010e54'/%3E%3Cpath d='M38.6738 29.6883C38.6738 29.6883 27.9939 29.6883 22.1738 29.6883M22.1738 29.6883C24.8351 29.6883 28.0287 32.1755 28.0287 34.9385M22.1738 29.6883C24.8351 29.6883 28.0287 27.2016 28.0287 24.4385' stroke='white' stroke-linecap='square'/%3E%3Cpath d='M52.8837 28.0751C53.6529 29.2431 53.6529 30.7569 52.8837 31.9249L51.3506 34.253C50.8172 35.0631 50.5597 36.0238 50.6167 36.9921L50.7803 39.7748C50.8625 41.1709 50.1056 42.4819 48.8554 43.1089L46.3637 44.3585C45.4967 44.7933 44.7933 45.4967 44.3585 46.3637L43.1089 48.8554C42.4819 50.1056 41.171 50.8625 39.7748 50.7803L36.9921 50.6167C36.0238 50.5597 35.0631 50.8172 34.253 51.3506L31.9249 52.8837C30.7569 53.6529 29.2431 53.6529 28.0751 52.8837L25.747 51.3506C24.9369 50.8172 23.9762 50.5597 23.0079 50.6167L20.2252 50.7803C18.8291 50.8625 17.5181 50.1056 16.8911 48.8554L15.6415 46.3637C15.2067 45.4967 14.5033 44.7933 13.6363 44.3585L11.1446 43.1089C9.89445 42.4819 9.13755 41.171 9.21966 39.7748L9.38331 36.9921C9.44026 36.0238 9.18282 35.0631 8.64937 34.253L7.11629 31.9249C6.34711 30.7569 6.34711 29.2431 7.11629 28.0751L8.64937 25.747C9.18282 24.9369 9.44026 23.9762 9.38331 23.0079L9.21966 20.2252C9.13755 18.8291 9.89445 17.5181 11.1446 16.8911L13.6363 15.6415C14.5033 15.2067 15.2067 14.5033 15.6415 13.6363L16.8911 11.1446C17.5181 9.89445 18.8291 9.13755 20.2252 9.21966L23.0079 9.38331C23.9762 9.44026 24.9369 9.18282 25.747 8.64937L28.0751 7.11629C29.2431 6.34711 30.7569 6.34711 31.9249 7.11629L34.253 8.64937C35.0631 9.18282 36.0238 9.44026 36.9921 9.38331L39.7748 9.21966C41.1709 9.13755 42.4819 9.89445 43.1089 11.1446L44.3585 13.6363C44.7933 14.5033 45.4967 15.2067 46.3637 15.6415L48.8554 16.8911C50.1056 17.5181 50.8625 18.8291 50.7803 20.2252L50.6167 23.0079C50.5597 23.9762 50.8172 24.9369 51.3506 25.747L52.8837 28.0751Z' stroke='white' stroke-linejoin='round'/%3E%3C/svg%3E")
      32 32,
    pointer;
  position: absolute;
  width: 10%;
  height: 100%;
  z-index: 10;
  top: 0;
  display: none;
  @media (min-width: 768px) {
    display: block;
  }
  ${(props) =>
    props.$staticArrows &&
    `
    cursor: default;
    display: block;
    :after {
      content: '';
      position: absolute;
      width: 40px;
      height: 40px;
      bottom: 40px;
      left: 16px;
      background-image: url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle r='20' transform='matrix(7.84791e-08 -1 -1 -7.15229e-08 20 20)' fill='%23FDF9F4'/%3E%3Cpath d='M25.7832 20.2076C25.7832 20.2076 18.6633 20.2076 14.7832 20.2076M14.7832 20.2076C16.5574 20.2076 18.6864 18.5495 18.6864 16.7075M14.7832 20.2076C16.5574 20.2076 18.6864 21.8654 18.6864 23.7075' stroke='%23A45A2A' stroke-linecap='square'/%3E%3Cpath d='M22.374 5.66199L22.649 5.2444L22.374 5.66199L21.9249 5.36628C20.7569 4.59711 19.2431 4.59711 18.0751 5.36629L17.626 5.66199C16.816 6.19544 15.8552 6.45288 14.8869 6.39593L14.3502 6.36436C12.9541 6.28226 11.6431 7.03916 11.0161 8.2893L10.7751 8.7699C10.3403 9.63692 9.63693 10.3402 8.76991 10.7751L8.2893 11.0161C7.03916 11.6431 6.28226 12.9541 6.36437 14.3502L6.39593 14.8869C6.45288 15.8552 6.19544 16.8159 5.66199 17.626L5.36629 18.0751C4.59711 19.2431 4.59711 20.7569 5.36629 21.9249L5.66199 22.374L5.2444 22.649L5.66199 22.374C6.19544 23.184 6.45288 24.1448 6.39593 25.1131L6.36437 25.6498C6.28226 27.0459 7.03916 28.3569 8.2893 28.9839L8.7699 29.2249C9.63693 29.6597 10.3403 30.3631 10.7751 31.2301L11.0161 31.7107C11.6431 32.9608 12.9541 33.7177 14.3502 33.6356L14.8869 33.6041C15.8552 33.5471 16.8159 33.8046 17.626 34.338L18.0751 34.6337C19.2431 35.4029 20.7569 35.4029 21.9249 34.6337L22.374 34.338C23.1841 33.8046 24.1448 33.5471 25.1131 33.6041L25.6498 33.6356C27.0459 33.7177 28.3569 32.9608 28.9839 31.7107L29.2249 31.2301C29.6597 30.3631 30.3631 29.6597 31.2301 29.2249L31.7107 28.9839C32.9608 28.3569 33.7177 27.0459 33.6356 25.6498L33.6041 25.1131C33.5471 24.1448 33.8046 23.1841 34.338 22.374L34.6337 21.9249C35.4029 20.7569 35.4029 19.2431 34.6337 18.0751L34.338 17.626C33.8046 16.8159 33.5471 15.8552 33.6041 14.8869L33.6356 14.3502C33.7177 12.9541 32.9608 11.6431 31.7107 11.0161L31.2301 10.7751C30.3631 10.3403 29.6598 9.63693 29.2249 8.7699L28.9839 8.2893C28.3569 7.03916 27.046 6.28226 25.6498 6.36436L25.1131 6.39593C24.1448 6.45288 23.1841 6.19544 22.374 5.66199Z' stroke='%23A45A2A' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
      background-repeat: no-repeat;
      background-position: 0 0;
      cursor: pointer;
      @media (min-width: 768px) {
        bottom: 66px;
        left: 64px;
      }
    }
  `};
`;
CarouselSlideLeft.displayName = 'CarouselSlideLeft';

export const CarouselSlideRight = styled.div<{
  $staticArrows?: boolean;
  onClick?: (e: MouseEvent) => void;
}>`
  cursor: url("data:image/svg+xml,%3Csvg width='60' height='60' viewBox='0 0 60 60' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle r='30' transform='matrix(-7.54979e-08 1 1 7.54979e-08 30 30)' fill='%23010e54'/%3E%3Cpath d='M21.3262 29.6883C21.3262 29.6883 32.0061 29.6883 37.8262 29.6883M37.8262 29.6883C35.1649 29.6883 31.9713 32.1755 31.9713 34.9385M37.8262 29.6883C35.1649 29.6883 31.9713 27.2016 31.9713 24.4385' stroke='white' stroke-linecap='square'/%3E%3Cpath d='M7.11629 28.0751C6.34711 29.2431 6.34711 30.7569 7.11628 31.9249L8.64936 34.253C9.18282 35.0631 9.44025 36.0238 9.38331 36.9921L9.21965 39.7748C9.13754 41.1709 9.89445 42.4819 11.1446 43.1089L13.6363 44.3585C14.5033 44.7933 15.2067 45.4967 15.6415 46.3637L16.8911 48.8554C17.5181 50.1056 18.829 50.8625 20.2252 50.7803L23.0079 50.6167C23.9762 50.5597 24.9369 50.8172 25.747 51.3506L28.0751 52.8837C29.2431 53.6529 30.7569 53.6529 31.9249 52.8837L34.253 51.3506C35.0631 50.8172 36.0238 50.5597 36.9921 50.6167L39.7748 50.7803C41.1709 50.8625 42.4819 50.1056 43.1089 48.8554L44.3585 46.3637C44.7933 45.4967 45.4967 44.7933 46.3637 44.3585L48.8554 43.1089C50.1055 42.4819 50.8625 41.171 50.7803 39.7748L50.6167 36.9921C50.5597 36.0238 50.8172 35.0631 51.3506 34.253L52.8837 31.9249C53.6529 30.7569 53.6529 29.2431 52.8837 28.0751L51.3506 25.747C50.8172 24.9369 50.5597 23.9762 50.6167 23.0079L50.7803 20.2252C50.8625 18.8291 50.1056 17.5181 48.8554 16.8911L46.3637 15.6415C45.4967 15.2067 44.7933 14.5033 44.3585 13.6363L43.1089 11.1446C42.4819 9.89445 41.1709 9.13755 39.7748 9.21966L36.9921 9.38331C36.0238 9.44026 35.0631 9.18282 34.253 8.64937L31.9249 7.11629C30.7569 6.34711 29.2431 6.34711 28.0751 7.11629L25.747 8.64937C24.9369 9.18282 23.9762 9.44026 23.0079 9.38331L20.2252 9.21966C18.8291 9.13755 17.5181 9.89445 16.8911 11.1446L15.6415 13.6363C15.2067 14.5033 14.5033 15.2067 13.6363 15.6415L11.1446 16.8911C9.89445 17.5181 9.13755 18.8291 9.21965 20.2252L9.38331 23.0079C9.44025 23.9762 9.18282 24.9369 8.64936 25.747L7.11629 28.0751Z' stroke='white' stroke-linejoin='round'/%3E%3C/svg%3E%0A")
      32 32,
    pointer;
  position: absolute;
  width: 10%;
  height: 100%;
  z-index: 10;
  top: 0;
  right: 0;
  display: none;
  @media (min-width: 768px) {
    display: block;
  }
  ${(props) =>
    props.$staticArrows &&
    `
    cursor: default;
    display: block;
    :after {
      content: '';
      position: absolute;
      width: 40px;
      height: 40px;
      bottom: 40px;
      right: 16px;
      background-image: url("data:image/svg+xml,%3Csvg width='40' height='40' viewBox='0 0 40 40' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Ccircle r='20' transform='matrix(8.94366e-09 1 1 -1.58998e-08 20 20)' fill='%23FDF9F4'/%3E%3Cpath d='M14.2168 19.7924C14.2168 19.7924 21.3367 19.7924 25.2168 19.7924M25.2168 19.7924C23.4426 19.7924 21.3136 21.4505 21.3136 23.2925M25.2168 19.7924C23.4426 19.7924 21.3136 18.1346 21.3136 16.2925' stroke='%23A45A2A' stroke-linecap='square'/%3E%3Cpath d='M17.626 34.338L17.351 34.7556L17.626 34.338L18.0751 34.6337C19.2431 35.4029 20.7569 35.4029 21.9249 34.6337L22.374 34.338C23.1841 33.8046 24.1448 33.5471 25.1131 33.6041L25.6498 33.6356C27.0459 33.7177 28.3569 32.9608 28.9839 31.7107L29.2249 31.2301C29.6597 30.3631 30.3631 29.6597 31.2301 29.2249L31.7107 28.9839C32.9608 28.3569 33.7177 27.0459 33.6356 25.6498L33.6041 25.1131C33.5471 24.1448 33.8046 23.1841 34.338 22.374L34.6337 21.9249C35.4029 20.7569 35.4029 19.2431 34.6337 18.0751L34.338 17.626L34.7556 17.351L34.338 17.626C33.8046 16.8159 33.5471 15.8552 33.6041 14.8869L33.6356 14.3502C33.7177 12.9541 32.9608 11.6431 31.7107 11.0161L31.2301 10.7751C30.3631 10.3403 29.6597 9.63693 29.2249 8.7699L28.9839 8.2893C28.3569 7.03916 27.0459 6.28226 25.6498 6.36436L25.1131 6.39593C24.1448 6.45288 23.1841 6.19544 22.374 5.66199L21.9249 5.36629C20.7569 4.59711 19.2431 4.59711 18.0751 5.36629L17.626 5.66199C16.8159 6.19544 15.8552 6.45288 14.8869 6.39593L14.3502 6.36436C12.9541 6.28226 11.6431 7.03916 11.0161 8.2893L10.7751 8.7699C10.3403 9.63693 9.63693 10.3403 8.7699 10.7751L8.2893 11.0161C7.03916 11.6431 6.28226 12.9541 6.36436 14.3502L6.39593 14.8869C6.45288 15.8552 6.19544 16.8159 5.66199 17.626L5.36629 18.0751C4.59711 19.2431 4.59711 20.7569 5.36629 21.9249L5.66199 22.374C6.19544 23.1841 6.45288 24.1448 6.39593 25.1131L6.36436 25.6498C6.28226 27.0459 7.03916 28.3569 8.2893 28.9839L8.7699 29.2249C9.63693 29.6597 10.3403 30.3631 10.7751 31.2301L11.0161 31.7107C11.6431 32.9608 12.9541 33.7177 14.3502 33.6356L14.8869 33.6041C15.8552 33.5471 16.8159 33.8046 17.626 34.338Z' stroke='%23A45A2A' stroke-linejoin='round'/%3E%3C/svg%3E%0A");
      background-repeat: no-repeat;
      background-position: 0 0;
      cursor: pointer;
      @media (min-width: 768px) {
        bottom: 66px;
        right: 64px;
      }
    }
  `};
`;
CarouselSlideRight.displayName = 'CarouselSlideRight';

export const CarouselDots = styled.ul<{ $dotsOnTop?: any; $staticArrows?: boolean }>`
  list-style: none;
  padding-left: 0;
  display: flex;
  justify-content: center;
  align-items: center;
  position: ${(props) => (props.$dotsOnTop > 0 ? 'absolute' : 'relative')};
  bottom: ${(props) => (props.$dotsOnTop > 0 ? `${props.$dotsOnTop}px` : '0')};
  left: ${(props) => (props.$dotsOnTop > 0 ? `50%` : '0')};
  transform: ${(props) => (props.$dotsOnTop > 0 ? `translateX(-50%)` : '0')};
  margin-top: ${(props) => (props.$dotsOnTop == 0 ? '20px' : '0px')};
  margin-bottom: ${(props) => (props.$dotsOnTop < 0 ? `${props.$dotsOnTop}px` : '0px')};
  ${(props) =>
    props.$staticArrows &&
    `
    @media (max-width: 767px) {
      top: -50px;
    }
  `};
`;

CarouselDots.displayName = 'CarouselDots';

export const CarouselDot = styled.li<{ $isOverlay: boolean }>`
  background-color: ${(props) => (props.$isOverlay ? '#EFDBB2' : '#9f9f9f')};
  width: 12px;
  height: 12px;
  margin-right: 12px;
  margin-bottom: 0;
  border-radius: 100%;
  cursor: pointer;

  &:last-child {
    margin-right: 0;
  }

  &.smaller {
    width: 10px;
    height: 10px;
  }
  &.active {
    background-color: ${(props) => (props.$isOverlay ? '#E1B87F' : '#5a5e5a')};
    width: 14px;
    height: 14px;
  }
`;

CarouselDot.displayName = 'CarouselDot';
